import ContentArea from 'component/common/ContentArea/ContentArea';
import { Button } from '@drone-js/core';
import React from 'react';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { StickyFooter } from 'component/common/StickyFooter/StickyFooter';

export interface FilterButtonsStickyFooterProps {
    cms: CmsValue;
    onClearButtonClick: () => void;
    onFilterWithSidebarButtonClick: () => void;
    visible: boolean;
}

const FilterButtonsStickyFooter: React.FC<FilterButtonsStickyFooterProps> = (props) => {
    return (
        <StickyFooter elementName="activities-sort-and-filter-sticky-footer">
            <ContentArea display={props.visible ? 'flex' : 'none'} justifyContent="space-evenly" width="100%">
                <Button
                    data-element-name="activities-sort-and-filter-clear-button"
                    data-testid="activities-sort-and-filter-clear-button"
                    size="l"
                    variant="label"
                    hierarchy="secondary"
                    width="parent-fit"
                    me="12"
                    onClick={props.onClearButtonClick}
                    label={props.cms[146545]}
                    aria-label={props.cms[146545]}
                />
                <Button
                    data-element-name="activities-sort-and-filter-apply-button"
                    data-testid="activities-sort-and-filter-apply-button"
                    size="l"
                    variant="label"
                    hierarchy="primary"
                    width="parent-fit"
                    onClick={props.onFilterWithSidebarButtonClick}
                    label={props.cms[146546]}
                    aria-label={props.cms[146546]}
                />
            </ContentArea>
        </StickyFooter>
    );
};

FilterButtonsStickyFooter.displayName = 'FilterButtonsStickyFooter';

export default FilterButtonsStickyFooter;
